import request from '@/untils/request'
export default {
   // banner 图
//    banner(params) {
//     return request({
//       url: "/ticket/banner/loadTicketList",
//       methods: "post",
//       params
//     })   
//   },

    // 票样列表 
    order(params){
        return request({
            url: "/ticket/infoList/findAllByAvailable",
            methods: "post",
            params
        })
    },

    // 查询入园须知 
    noticeList(params){
        return request({
            url: "/ticket/admissionnotice/loadAdmissionNoticeList",
            methods: "post",
            params
        })
    }, 

  // 购票须知的接口
  loadNoticeList(data) {
    return request({
       url: "/ticket/ticketinstructions/loadAdmissionNoticeList",
       method: "post",
       params: data    
    });
  },  

   //退出登录
   logout(params) {
    return request({
      url: "/logout",
      methods: "post",
      params
    }) 
   },

   // 查询个人信息
   ticketAppUser(params) {
    return request({
      url: "/ticketAppUser/profile",
      methods: "post",
      params
    }) 
   },

    
};



// WEBPACK FOOTER //
// ./src/api/homepage.js